export default {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,000 BCE"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [136.87458235601747, -0.6078423421738677],
          [136.93541557477408, -0.589137834628005],
          [137.11211888511986, -0.5363955270394172],
          [137.39599776816442, -0.45467200720219125],
          [137.77835770502236, -0.34902390365735414],
          [138.2505041768033, -0.2245082330364454],
          [138.8037426646203, -0.0861825785801642],
          [139.42937864958458, 0.060894919738842646],
          [140.11871761280747, 0.2116657418837491],
          [141.65372639847783, 0.5040531714477794],
          [143.33921287052812, 0.750515507809709],
          [145.1056208778524, 0.910599013148726],
          [146.8833942693443, 0.9438573480999679],
          [148.67518496797442, 0.7915029478551645],
          [150.48152335833913, 0.45957820844401454],
          [152.22967098176701, 0.004892000712032996],
          [153.84688937958464, -0.5157113998057099],
          [154.58366935055437, -0.7829604739261242],
          [155.26044009311886, -1.0453630330776207],
          [155.868109299945, -1.2958130924042734],
          [156.39758466369813, -1.5272082190663525],
          [156.83977387704493, -1.732450179588426],
          [157.18558463265072, -1.9044448413251445],
          [157.42592462318083, -2.036101204584213],
          [157.5517015413019, -2.120329554405089],
          [157.77623100265942, -2.277812424853124],
          [158.15101162986412, -2.533146876816275],
          [158.62061946443663, -2.909530937679989],
          [159.1296305479005, -3.4300799575050434],
          [159.62262092178304, -4.117757531268438],
          [160.04416662760622, -4.995259529660714],
          [160.21082774297167, -5.512170026841204],
          [160.3388437068955, -6.084827947147772],
          [160.4212865245653, -6.7158958459811515],
          [160.4512282011715, -7.40796513422265]
        ]
      },
      "id": 0
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,500 BCE",
        "label_line_2": ""
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [123.09338021610296, 18.35511671125022],
          [123.14450550255066, 18.376797515853056],
          [123.29507790046267, 18.437079546309604],
          [123.54089221770096, 18.528809978819183],
          [123.87774326212076, 18.644830702197467],
          [124.30142584158045, 18.777989791752447],
          [124.8077347639387, 18.921150238286145],
          [125.39246483705239, 19.06719591397352],
          [126.0514108687816, 19.20903469106159],
          [126.78036766698176, 19.339598592230672],
          [127.57513003951277, 19.451840842216612],
          [128.4314927942334, 19.538729707858806],
          [129.3452507389988, 19.593239056938117],
          [130.31219868166914, 19.60833563426229],
          [131.3281314301014, 19.576963146455526],
          [132.38884379215403, 19.49202336585013],
          [133.49013057568544, 19.346354611265184],
          [134.58775202282112, 19.147256927178304],
          [135.6391731833175, 18.910398628715697],
          [137.59682272156635, 18.344760739320606],
          [139.34989534480098, 17.69239513566815],
          [140.8852072073837, 16.99678867677018],
          [141.56708290167126, 16.646537951219287],
          [142.1895744636821, 16.302081959165562],
          [142.75103391271313, 15.969039107249344],
          [143.24981326805994, 15.653061763686622],
          [143.68426454901987, 15.359830673090968],
          [144.05273977488667, 15.095048306088302],
          [144.3535909649558, 14.864431279289363],
          [144.58517013852276, 14.673701924361566]
        ]
      },
      "id": 1
    },
    {
      "type": "Feature",
      "properties": { "layer_id": "migration_wave_2", "label_line_1": "" },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [161.43650677488301, -11.073959650902808],
          [161.44941310258747, -11.129654858406681],
          [161.4895485674224, -11.28851299551495],
          [161.55903789197458, -11.538127839612685],
          [161.66000579882967, -11.866034463655254],
          [161.79457701057106, -12.259740595446658],
          [161.96487624978613, -12.706755259556047],
          [162.42115770097485, -13.710912554012609],
          [163.04584793307703, -14.77958127881999],
          [163.85594472677576, -15.815342423562925],
          [164.33583239068588, -16.29095002050262],
          [164.86844586275248, -16.72264793841049],
          [165.4559098655593, -17.09876571295409],
          [166.10034912168993, -17.407700913872162],
          [167.48767311373922, -17.85032036288129],
          [168.9312205342003, -18.11695697162378],
          [170.39516529147727, -18.24416307957614],
          [171.84368129398428, -18.268003885051016],
          [173.24094245012384, -18.224293243218526],
          [174.55112266830827, -18.148767189403614],
          [175.73839585694168, -18.0771860733188],
          [176.76693592443655, -18.045362864487288]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,000 BCE",
        "text_anchor": "right",
        "text_offset": [-3, -3],
        "text_justify": "right"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [168.0194421447818, -18.13021193187737],
          [168.03835762379595, -18.17307656568137],
          [168.0870845950858, -18.290186138086924],
          [168.22585621993596, -18.678078660201464],
          [168.33952343024123, -19.156015482796136],
          [168.33185263690683, -19.587245422894426],
          [168.15333235568903, -19.974728649038042],
          [167.89113069265073, -20.355377672417944],
          [167.6540334441591, -20.6450637541124],
          [167.57889453673317, -20.729669458421156],
          [167.55082640658117, -20.760197460506774]
        ]
      },
      "id": 3
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,250 CE"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [-188.77926714489365, -45.93437053665052],
          [-188.66817118795558, -45.95384961007205],
          [-188.34929417588364, -46.00182787032995],
          [-187.84425239679294, -46.06262228443695],
          [-187.17466213879683, -46.120597884598894],
          [-186.36213969000713, -46.16018204170146],
          [-185.42830133854054, -46.16583459816812],
          [-184.3947633725088, -46.1219738731254],
          [-183.28314208002536, -46.012858521900796],
          [-182.17747629549157, -45.848192071090644],
          [-181.15739336593833, -45.657142040696],
          [-180.23789234842502, -45.45306079120666],
          [-179.43397230000758, -45.24948068337493],
          [-178.76063227774708, -45.060127595164445],
          [-178.23287133869948, -44.89890152146974],
          [-177.86568853992583, -44.779824254123284],
          [-177.67408293848376, -44.716954170184344]
        ]
      },
      "id": 4
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,000 - 1,150 CE"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [-140.19019817248628, -7.00657586750205],
          [-140.17120610170423, -6.953366090918934],
          [-140.11764300814374, -6.7971248596148115],
          [-140.03462856998902, -6.542891244229267],
          [-139.92728246541935, -6.195661116841464],
          [-139.80072437262055, -5.76040637370005],
          [-139.66007396977363, -5.242094780857215],
          [-139.51045093505948, -4.645709336580339],
          [-139.35697494666397, -3.9762662128277526],
          [-139.2047656827647, -3.238830491564528],
          [-139.0589428215476, -2.438529056050882],
          [-138.80693501988677, -0.6701991553574373],
          [-138.64190896713714, 1.2862038819832975],
          [-138.6048220887576, 3.3869595435142514],
          [-138.67350670602238, 5.497177231623027],
          [-138.80299409922495, 7.505343773818936],
          [-139.00004013235915, 9.402653169250215],
          [-139.2714006694188, 11.181109039593409],
          [-139.62383157439604, 12.833472937701785],
          [-140.0640887112848, 14.353185580039735],
          [-140.5989279440771, 15.734265825774855],
          [-141.23510513676854, 16.971192341314918],
          [-141.99155078325362, 18.059307961725338],
          [-142.86157939312426, 19.002650846543233],
          [-143.81352285391276, 19.808840750110562],
          [-144.81571305315148, 20.48523534695225],
          [-145.8364818783712, 21.03890374345376],
          [-146.84416121710254, 21.476618500922825],
          [-147.8070829568812, 21.804861678530656],
          [-148.69357898523626, 22.02984121212134],
          [-149.51526094340596, 22.171135879129636],
          [-150.30823047960484, 22.2462570435043],
          [-151.07755449182778, 22.258046044265228],
          [-151.8282998780698, 22.2092552853762],
          [-152.5655335363258, 22.10256010854205],
          [-153.2943223645891, 21.94057094104744],
          [-154.74683312312243, 21.46090069182938]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": { "layer_id": "migration_wave_2" },
      "geometry": { "type": "LineString", "coordinates": [] }
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "100 BCE",
        "text_anchor": "left",
        "text_offset": [0.5, 0],
        "text_justify": "left"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [168.96940463084945, -14.440631073148367],
          [169.01968089158078, -14.412951128389352],
          [169.1640529875687, -14.33069419125924],
          [169.39283588949877, -14.195006272392561],
          [169.696344568058, -14.00699878825013],
          [170.06489399393172, -13.767752930194561],
          [170.4887991378087, -13.478324425688626],
          [170.9583749703727, -13.139748614492433],
          [171.46393646231235, -12.753045769025874],
          [172.54427630706545, -11.839297834632006],
          [173.6523384375608, -10.74515280629042],
          [174.71064261928848, -9.478800469386286],
          [175.1969229060822, -8.783681664696644],
          [175.64170861774312, -8.04872472719397],
          [176.0441778595851, -7.317822882074722],
          [176.41052816183054, -6.632765893257101],
          [177.03824837977294, -5.391796301531301],
          [177.53162213604878, -4.30849452912183],
          [177.8974022951317, -3.3648684461184786],
          [178.14234172149702, -2.5424754818374],
          [178.27319327961976, -1.82257882807383],
          [178.29670983397864, -1.1862551875330922],
          [178.21964424904553, -0.6144671702701601],
          [177.99970226836774, -0.1356178015141296],
          [177.62586606043772, 0.23093166917287533],
          [177.15180312713545, 0.517862747884223],
          [176.63118097034652, 0.7578705653378393],
          [176.11766709195103, 0.9836506529962179],
          [175.66492899383593, 1.2278928091611903],
          [175.32663417788, 1.5232747697168065],
          [175.15645014596993, 1.9024496994272369],
          [175.1315306915775, 2.151982193943468],
          [175.12127926844852, 2.4623070260248596],
          [175.12238532070813, 3.227335751745713],
          [175.11497791220484, 4.121496492283271],
          [175.05426665239287, 5.068796831620389],
          [174.8954611507284, 5.993502164238265],
          [174.59377101666752, 6.820335564010861],
          [174.37534721544188, 7.173676184622494],
          [174.1044058596645, 7.474562452635141],
          [173.7753481505132, 7.713717354839957],
          [173.38257528917376, 7.8818687265521135],
          [172.97771350284086, 7.9890348464102345],
          [172.6139351404035, 8.054351278595092],
          [171.99651022207303, 8.076966205414521],
          [171.50406360391213, 7.984674661958408],
          [171.1103583556527, 7.812349878626492],
          [170.78915754702274, 7.594862436167048],
          [170.5142242477524, 7.367133083416732],
          [170.25932152757326, 7.164152192017681],
          [169.9982124562136, 7.020969552393851],
          [169.44202340300723, 6.808375032884541],
          [168.8143655466004, 6.591219356619149],
          [168.0388554995767, 6.390922669347049],
          [167.57178609601505, 6.303799376168527],
          [167.039109874516, 6.2289373581246394],
          [166.4298836186013, 6.175757751401505],
          [165.7612589707939, 6.148621630757631],
          [164.37619195980926, 6.152838730271512],
          [163.72493832677947, 6.174365139379759],
          [163.1446637621587, 6.202284427239903],
          [162.6679626310222, 6.231682911885784],
          [162.32742929844545, 6.257647919620524]
        ]
      },
      "id": 7
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "880 BCE",
        "text_anchor": "center",
        "text_offset": [0, 0],
        "text_justify": "center"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [-179.92410387864646, -15.656685705813501],
          [-179.84372109712965, -15.602264433284333],
          [-179.61655236675227, -15.473170210523804],
          [-179.26356710877997, -15.320687458924453],
          [-178.80573474448155, -15.196220214868461],
          [-178.26402469511928, -15.151284209967713],
          [-177.65940638196034, -15.237374569168594],
          [-177.0128492262703, -15.505708201889504],
          [-176.68039652662182, -15.724050461446424],
          [-176.34532264931306, -16.00682342392504],
          [-175.74686484409727, -16.582887460096856],
          [-175.2823980866297, -17.04988810477792],
          [-174.9352179226806, -17.41808485253138],
          [-174.68861989802184, -17.697527998818444],
          [-174.52589955842691, -17.89808876170214],
          [-174.4303524496644, -18.029492288484178],
          [-174.38527411750786, -18.101350881812962],
          [-174.37396010772918, -18.123195466710825]
        ]
      },
      "id": 8
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "800 BCE",
        "text_anchor": "top",
        "text_offset": [-1, 1],
        "text_justify": "left"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [-173.634463505911, -19.6028056179142],
          [-173.5953596808777, -19.60143441622735],
          [-173.48491713363546, -19.596273046678704],
          [-173.0912294396916, -19.56829092168934],
          [-172.53582755840435, -19.506269175054612],
          [-171.90113862410033, -19.397581349682426],
          [-171.2695897711028, -19.2295338741729],
          [-170.72360813373837, -18.98932689126454],
          [-170.50846350039674, -18.838123303308606],
          [-170.34562084633362, -18.664008032334934],
          [-170.24538356334205, -18.465329806872816],
          [-170.21805504321017, -18.240421308933264],
          [-170.27974455723395, -17.723288438061914],
          [-170.40070310593794, -17.15103440577373],
          [-170.7372151527387, -15.991837871190938],
          [-170.9111625735099, -15.481371275435308],
          [-171.06116687431017, -15.068587470166904],
          [-171.16642501647505, -14.792424273911038],
          [-171.20613396134505, -14.691769901690222]
        ]
      },
      "id": 9
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,000 - 1,200 CE"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [-144.07167429345702, -18.516215513247474],
          [-144.09175234492693, -18.564144430369467],
          [-144.15078780969893, -18.704095292381112],
          [-144.24698265331037, -18.930214532737025],
          [-144.37853884130203, -19.23653560452675],
          [-144.54365833921304, -19.61700162754795],
          [-144.74054311258573, -20.065486096679606],
          [-144.96739512695922, -20.575812489235645],
          [-145.22241634787258, -21.141773394083856],
          [-145.80977427148036, -22.4157292024684],
          [-146.48823260773005, -23.837805028519853],
          [-147.24340708093936, -25.35919217913819],
          [-148.06091341543092, -26.932426903173173],
          [-149.82538456553493, -30.054458103292163],
          [-150.74358082978773, -31.51930826070219],
          [-151.66657185260019, -32.868403609131946],
          [-152.57997335829333, -34.06606147958098],
          [-153.0285829560691, -34.59749825269345],
          [-153.46940107118482, -35.078537374953434],
          [-153.9006296691812, -35.50514715961801],
          [-154.3204707155957, -35.87331540433427],
          [-154.72712617597233, -36.17901469801483],
          [-155.11879801584695, -36.41816452906126],
          [-156.65731616880873, -37.1942701692001],
          [-158.22100680421167, -37.89061916225702],
          [-159.83504240449355, -38.51294410474526],
          [-161.52459545209723, -39.066678239436264],
          [-163.31483842946045, -39.556980015574624],
          [-165.23094381902771, -39.98875864331241],
          [-167.29808410323685, -40.36669983348766],
          [-169.54143176452732, -40.695291117036476],
          [-170.70236268088365, -40.82587373571233],
          [-171.8405184940795, -40.91539369616919],
          [-172.94870706627452, -40.968485656874684],
          [-174.01973625962844, -40.98970483521124],
          [-175.04641393630257, -40.98354999681112],
          [-176.02154795845655, -40.954483483793496],
          [-176.9379461882501, -40.90694824603454],
          [-177.7884164878412, -40.84538185315784],
          [-178.56576671939288, -40.77422747483164],
          [-179.2628047450615, -40.69794182434066],
          [-179.87233842701167, -40.62100006605465],
          [-180.3871756273981, -40.547897691560934],
          [-180.80012420838378, -40.48314937181343],
          [-181.10399203212842, -40.43128479344489],
          [-181.29158696079165, -40.396841486036585],
          [-181.3557168565315, -40.38435464339478]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": { "layer_id": "migration_wave_2", "label_line_1": "" },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [173.54071817379486, -34.40079757087288],
          [173.53209149670647, -34.35348385580533],
          [173.5061802376497, -34.21884537923897],
          [173.4629375549382, -34.007685930512274],
          [173.40231660688863, -33.730695432096645],
          [173.22875254802796, -33.02196813855168],
          [172.98511332758375, -32.17913377755545],
          [172.67102421207068, -31.291286704563262],
          [172.28611046800506, -30.450900856350124],
          [172.06697725605233, -30.07829515092228],
          [171.8299973619031, -29.753621242268586],
          [171.57512394387436, -29.489152217566073],
          [171.30231016028114, -29.29718014987727],
          [170.75676066256773, -29.04790806954565],
          [170.25355604859146, -28.89420534453788],
          [169.80206465546394, -28.817131668672225],
          [169.41165482029515, -28.797484889682657],
          [169.09169488019364, -28.815927794353712],
          [168.85155317227094, -28.853077318762104],
          [168.7005980336371, -28.889557381185142],
          [168.64819780140073, -28.906015703345474]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,000 - 1,200 CE",
        "text_anchor": "top",
        "text_offset": [1, 1],
        "text_justify": "center"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [-169.0377768868704, -14.94763388198065],
          [-168.97409395483697, -14.99401283643661],
          [-168.78675162437892, -15.125029351101986],
          [-168.4813095939563, -15.328448057035274],
          [-168.06332756203417, -15.591993209730688],
          [-167.53836522707093, -15.9033846812425],
          [-166.9119822875316, -16.25036880760588],
          [-166.1897384418779, -16.620744395367396],
          [-165.37719338857153, -17.002383618824496],
          [-164.47990682607426, -17.38324712802448],
          [-163.50343845284775, -17.75139243595173],
          [-162.45334796735543, -18.094974554445983],
          [-161.33519506805732, -18.40223789078057],
          [-160.15453945341847, -18.661498586718537],
          [-158.91694082189892, -18.86111676582108],
          [-157.62795887196208, -18.989458542899428],
          [-156.293153302068, -19.034848138357944],
          [-154.98276904476265, -19.035152255821046],
          [-153.76015758399387, -19.034472292938744],
          [-152.62053844532778, -19.030419717177566],
          [-151.5591311543322, -19.020605620165924],
          [-150.57115523657322, -19.00264006178044],
          [-149.65183021761703, -18.97413107361014],
          [-148.79637562302977, -18.932683326421753],
          [-148.00001097838089, -18.875896469761614],
          [-146.5654296411578, -18.70666677022062],
          [-145.30984241048355, -18.447056470858925],
          [-144.1950054908906, -18.07744502108835],
          [-143.18267508691468, -17.57788032132551],
          [-142.71531162246447, -17.251855673069983],
          [-142.28629273185587, -16.85333942318863],
          [-141.89448805220903, -16.394757070964204],
          [-141.5387672206459, -15.888611895316743],
          [-140.93105565024814, -14.78422368963821],
          [-140.4541151176327, -13.642718860826392],
          [-140.09890271976457, -12.568792348303674],
          [-139.9641186641648, -12.090377372377887],
          [-139.85637555361546, -11.668855781985442],
          [-139.77454302523668, -11.317669293213967],
          [-139.71749071614872, -11.05026004778513],
          [-139.68408826347513, -10.88003857840765],
          [-139.67320530433443, -10.820348978942832]
        ]
      },
      "id": 12
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,000 - 1,200 CE",
        "text_anchor": "bottom",
        "text_offset": [-3, -3],
        "text_justify": "left"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [-139.32121685423832, -11.20886683098935],
          [-139.31378690297691, -11.266325157380308],
          [-139.28786431075196, -11.432799489170364],
          [-139.23799996989902, -11.699357862215138],
          [-139.15874477275867, -12.056979840225807],
          [-139.0446496116681, -12.49657803930134],
          [-138.8902653789645, -13.009017957177647],
          [-138.6901429669852, -13.58513762005137],
          [-138.43883326806903, -14.215767989744336],
          [-138.13088717455156, -14.891754557393625],
          [-137.76085557877332, -15.603980096393812],
          [-137.3232893730716, -16.34338816492607],
          [-136.81273944978187, -17.1010066431069],
          [-136.22375670124313, -17.867970365512875],
          [-135.5508920197942, -18.635541767406266],
          [-134.78869629777228, -19.395128399962758],
          [-133.93172042751468, -20.138296180370645],
          [-133.03489885135912, -20.835365145008083],
          [-132.15854360870622, -21.46518729887758],
          [-131.30527198748925, -22.032174819656248],
          [-130.47770127563973, -22.54063963340927],
          [-129.67844876109083, -22.99479665293211],
          [-128.91013173177248, -23.398769019513168],
          [-128.1753674756195, -23.756594739347165],
          [-127.47677328056352, -24.072234210862092],
          [-126.19856422547018, -24.592456129587646],
          [-125.0964428699498, -24.98987132571051],
          [-124.19134751746304, -25.29417944922973],
          [-123.81922781218552, -25.420551955321997],
          [-123.50421647146558, -25.53455865321314],
          [-122.8205751427091, -25.769768913859338],
          [-121.94539982494534, -26.029499784399093],
          [-120.92880514611942, -26.29911994158467],
          [-119.82090573417975, -26.564123384314243],
          [-117.53165122276111, -27.02290204951192],
          [-116.45052537917732, -27.188256031313934],
          [-115.47855331427843, -27.29206905706478],
          [-113.62316791058205, -27.35671878865655],
          [-112.71778651569738, -27.34742008755424],
          [-111.88311480134297, -27.321349076470277],
          [-111.16102937443516, -27.286730721187098],
          [-110.5934068418903, -27.25179642226604],
          [-110.22212381062472, -27.224787282642062],
          [-110.12319604763333, -27.21683207086037],
          [-110.08905688755478, -27.21395126653144]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "",
        "label_line_2": ""
      },
      "geometry": { "type": "LineString", "coordinates": [] }
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "4,000 BCE",
        "text_anchor": "left",
        "text_offset": [0.5, 0],
        "text_justify": "left"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [120.58687319978361, 21.79577050737028],
          [120.56813325772924, 21.76986491056344],
          [120.51849630073224, 21.694981072135576],
          [120.36602855688585, 21.415124114621207],
          [120.20846439820355, 20.98967427497604],
          [120.1247982546443, 20.452026575981023],
          [120.1770365067145, 19.880542772606404],
          [120.3184620184158, 19.380323211312202],
          [120.46498394495302, 19.025576951973576],
          [120.51387767478741, 18.926050203856036],
          [120.5325114415312, 18.890818825651692]
        ]
      },
      "id": 16
    },
    {
      "type": "Feature",
      "properties": { "layer_id": "migration_wave_2", "label_line_1": "" },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [126.52105794552983, 6.605786361061533],
          [126.53771128018735, 6.570468251953841],
          [126.58652857300137, 6.469597278621535],
          [126.66579575724006, 6.310784292020813],
          [126.77379876616283, 6.101629750812208],
          [127.06915599112847, 5.562701182653669],
          [127.45888771401087, 4.913722542895087],
          [127.9292814009259, 4.215846609086995],
          [128.46662451798954, 3.5304934107752075],
          [129.05720453131266, 2.9192862673158118],
          [129.68730890701295, 2.4439479582894847],
          [130.32727196720458, 2.092582681225423],
          [130.9438430578266, 1.8080559719361986],
          [131.51793218072567, 1.5842276521115934],
          [132.0304493377471, 1.4149403997369063],
          [132.46230453073576, 1.2940260832371138],
          [132.79440776153683, 1.2153099271027656],
          [133.00766903199707, 1.1726131714737278],
          [133.08299834396337, 1.1597547333831102]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_2",
        "label_line_1": "1,500 BCE",
        "text_anchor": "left",
        "text_offset": [0.5, 0],
        "text_justify": "left"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [128.79249885268206, 3.5437325544963585],
          [128.82428190712074, 3.5337473056744386],
          [128.91555316003382, 3.5067877161341556],
          [129.2520927988577, 3.4199213672907263],
          [129.75318284430705, 3.3190892917511405],
          [130.36988837153712, 3.240259518886262],
          [131.05327445569958, 3.219410203300157],
          [131.75440617194977, 3.292515137433213],
          [132.4243485954393, 3.4955161181653978],
          [133.01416680132513, 3.8642750170269977],
          [133.4817373194992, 4.337083606172854],
          [133.8293903844779, 4.814419135307432],
          [134.07487162835054, 5.275356105682505],
          [134.23592668320146, 5.699031028015909],
          [134.33030118111816, 6.064645057212786],
          [134.37574075419008, 6.351453876006644],
          [134.38999103450135, 6.538742694733429],
          [134.3907976541431, 6.605786361054982]
        ]
      },
      "id": 17
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_1",
        "label_line_2": "Years Ago",
        "label_line_1": "50,000 - 60,000"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [118.64625497591419, 3.9834774549042464],
          [118.65329911628618, 3.9322954657921656],
          [118.67806722275185, 3.784824320723331],
          [118.72601282334239, 3.5501581604488592],
          [118.80258944608738, 3.237378717393156],
          [118.91325061901483, 2.855569240102639],
          [119.06344987015422, 2.413826260017302],
          [119.2586407275353, 1.921268157949953],
          [119.50427671918754, 1.3870399668508497],
          [119.80581137314056, 0.8203142683728544],
          [120.16869821742222, 0.2302884043763953],
          [120.59839078006218, -0.37382147066779225],
          [121.10034258908996, -0.9827887276296678],
          [121.68000717253523, -1.587386045249886],
          [122.3428380584275, -2.178395583889696],
          [123.09428877479644, -2.746618461151371],
          [123.93981284966816, -3.282882476319841],
          [124.80608589446524, -3.7584554650217257],
          [125.61688633383983, -4.154734948665549],
          [126.37332191567242, -4.477760998181864],
          [127.0765003878438, -4.733560376621],
          [127.72752949823456, -4.928142663067561],
          [128.32751699472698, -5.067499447823053],
          [128.8775706252, -5.157605602042622],
          [129.37879813753773, -5.204421818095085],
          [130.23920579932457, -5.191975549536039],
          [130.91760196313282, -5.077684764964019],
          [131.4228486120124, -4.90904070610938],
          [131.76380772900865, -4.733560376621],
          [132.18554722994168, -4.464027078207579],
          [132.43277383393468, -4.2950082716340034],
          [132.54911576522585, -4.207538704346234],
          [132.57820124804863, -4.182610336011763]
        ]
      },
      "id": 18
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_1",
        "label_line_1": "40,000",
        "label_line_2": "Years Ago"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [142.61640698857832, -2.768885521701307],
          [142.72869541969692, -2.739784883669472],
          [143.04326856259735, -2.6683530614437103],
          [143.52668819160158, -2.578395987173309],
          [144.14551608103073, -2.4937246911555775],
          [144.8663140052035, -2.43815617993603],
          [145.65564373844393, -2.4355100027001555],
          [146.48006705506947, -2.509600979842645],
          [147.3061457294025, -2.6842271623178107],
          [148.09398564070426, -2.9406636778139017],
          [148.8175976729807, -3.230426887882615],
          [149.46440110765548, -3.532664308977999],
          [150.02181522615774, -3.8265450406817365],
          [150.47725930991635, -4.091265462875313],
          [150.8181526403567, -4.306049383301698],
          [151.03191449890778, -4.450140386046343],
          [151.1059641669953, -4.502785209574256]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "layer_id": "migration_wave_1",
        "label_line_1": "20,000",
        "label_line_2": "Years Ago"
      },
      "geometry": {
        "type": "LineString",
        "coordinates": [
          [151.85818169441603, -5.874948728652555],
          [151.83563521073046, -5.968461620835555],
          [151.79449243591836, -6.222563684555851],
          [151.7744983843487, -6.59753858243738],
          [151.81539807038712, -7.0536585214669],
          [151.95693650840434, -7.551262272408522],
          [152.2388587127657, -8.05082108600459],
          [152.70090969784036, -8.51298354135865],
          [153.01190380013475, -8.717795605517082],
          [153.38283447799716, -8.898585031994273],
          [154.2606280369119, -9.195364654693705],
          [155.23906034780367, -9.423197344383397],
          [156.25103890935492, -9.591202032454618],
          [157.22947122024664, -9.708450392472074],
          [158.1072647791613, -9.783978086519085],
          [158.81732708477983, -9.82679545036413],
          [159.088492610941, -9.838748890104299],
          [159.29256563578315, -9.845896795554765],
          [159.4211595966437, -9.849362164175517],
          [159.46588793085692, -9.85026779447108]
        ]
      },
      "id": 20
    }
  ]
}
